module.exports = __webpack_public_path__ + "img/accident.b633871a.svg";